import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map, skip } from 'rxjs/operators';

import { LocalStorageService } from '@recruitee/common';

import { Colors as DarkTheme } from './../theme/dark/ts/colors';
import { Colors as LightTheme } from './../theme/light/ts/colors';

export const SupportedThemes = { light: LightTheme, dark: DarkTheme };

export type SupportedThemesT = keyof typeof SupportedThemes;
export type Theme = typeof SupportedThemes[SupportedThemesT];

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public static readonly DEFAULT_THEME: SupportedThemesT = 'light';
  private static readonly LS_KEY: string = 'theme';

  public theme$: Observable<Theme>;
  private supportedThemes$: BehaviorSubject<SupportedThemesT>;

  constructor(ls: LocalStorageService) {
    this.supportedThemes$ = new BehaviorSubject(
      ls.get(ThemeService.LS_KEY, ThemeService.DEFAULT_THEME),
    );
    this.theme$ = this.supportedThemes$
      .asObservable()
      .pipe(map(theme => SupportedThemes[theme] || SupportedThemes[ThemeService.DEFAULT_THEME]));
    this.supportedThemes$.pipe(skip(1)).subscribe(theme => ls.set(ThemeService.LS_KEY, theme));
  }
}
